<template>
    <div class="cart__coupon">
        <h3>Have a Coupon/Gift Certificate?</h3>
        <div class="form">
            <div class="form-group">
                <label for="coupon-code">Coupon or Gift Code</label>
                <input name="coupon-code" type="text" id="coupon-code" v-model="inputData" max="100">
            </div>
            <button class="btn btn-primary" @click.prevent="applyCoupon" type="button">Apply <span class="sr-only">coupon</span></button>
        </div>
        <div class="form" v-if="message">
            <div class="form-group">
                <small class="text-muted">{{ message }}</small>
            </div>
        </div>
        <div v-if="checkout.coupons.length > 0" class="applied_coupons">
            <div v-for="coupon in checkout.coupons" class="item">
              <div>
                <div>
                  <span v-if="coupon.is_redeemed">{{ coupon.code }} has been applied</span>
                  <span v-else>{{ coupon.code }} has not been applied</span>
                  <span @click.prevent="removeCoupon(coupon.id)" class="fas fa-times"></span>
                </div>
                <template v-if="coupon.description">
                  <p>{{ coupon.description }}</p>
                </template>
              </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import CheckoutApi from '@support/checkoutApi'
import {mapGetters} from 'vuex';

export default Vue.extend({
        name: "cartCoupon",
        watch: {
            'checkout.coupon': function () {
                this.inputData = this.checkout.coupon
            }
        },
        data: () => ({
            inputData: '',
        }),
        computed: {
            ...mapGetters('checkout', [
                'checkout'
            ]),
            message() {
                return this.checkout.coupon_message
            },
        },
        methods: {
            applyCoupon: function () {
                const coupon = this.inputData;
                if (!coupon) {
                    return false;
                }
                CheckoutApi.applyCoupon(coupon).then(r => {
                    this.$store.dispatch('shippingMethods/fetchShipping');
                    this.$store.dispatch('updateCheckout', r.data);
                    this.$emit('couponChanged');
                });
            },
            removeCoupon: function (couponId) {
                CheckoutApi.removeCoupon(couponId).then(r => {
                    this.$store.dispatch('shippingMethods/fetchShipping');
                    this.$store.dispatch('updateCheckout', r.data);
                    if (r.data.coupons.filter(item => item.has_shipping_discounts).length > 0) {
                        this.$emit('couponChanged');
                    }
                }).catch(e => console.error(e));
            }
        }
    });
</script>
